export default function Hero() {
  return (
    <section id="top" className="hero">
      <div className="container">
        <div className="hero-grid" style={{ marginTop: 28 }}>
          <h1 className="h1">
            A <span className="em-red">federation</span>{' '}
            <br className="br-hero" />
            of engineering{' '}
            <br className="br-hero" />
            companies, keeping{' '}
            <br className="br-hero" />
            Japan running.
          </h1>
          <p className="lede">
            Mystar Engineering Group is a privately held federation of specialised
            Japanese engineering companies — covering manufacturing mechatronics and
            critical-infrastructure services. Acquired companies operate independently;
            shared platforms support them underneath.
          </p>
        </div>
      </div>
    </section>
  );
}
